import React from "react";
import { MessageCircle, X } from "lucide-react";
import { useSettings, buildWhatsappUrl } from "@/context/SettingsContext";
import { trackEvent } from "@/lib/analytics";

export default function WhatsAppFloatingButton() {
  const settings = useSettings();
  const [open, setOpen] = React.useState(false);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const t = setTimeout(() => setShow(true), 1500);
    return () => clearTimeout(t);
  }, []);

  const onChat = () => {
    trackEvent("whatsapp_click", { source: "floating" });
    window.open(buildWhatsappUrl(settings.whatsapp_number, settings.whatsapp_message), "_blank");
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-3" data-testid="whatsapp-floating">
      {open && (
        <div className="glass-strong border border-white/10 rounded-2xl p-4 w-72 shadow-[0_20px_60px_rgba(0,0,0,0.5)] animate-in fade-in slide-in-from-bottom-2">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-emerald-500 flex items-center justify-center">
                <MessageCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <div className="text-white text-sm font-medium">MFB Advisor</div>
                <div className="text-emerald-400 text-[10px] uppercase tracking-widest">Online now</div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-slate-400 hover:text-white"
              data-testid="whatsapp-close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="mt-3 text-slate-300 text-xs leading-relaxed">
            Hi there 👋 Got questions about investments, gold, forex or travel? Chat with our advisor on WhatsApp.
          </p>
          <button
            onClick={onChat}
            data-testid="whatsapp-start-chat"
            className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-600 transition"
          >
            <MessageCircle className="w-4 h-4" /> Start WhatsApp chat
          </button>
        </div>
      )}
      <button
        onClick={() => (open ? onChat() : setOpen(true))}
        data-testid="whatsapp-fab"
        aria-label="Open WhatsApp chat"
        className="relative w-14 h-14 rounded-full bg-emerald-500 text-white shadow-[0_10px_30px_rgba(16,185,129,0.45)] hover:bg-emerald-600 hover:shadow-[0_15px_45px_rgba(16,185,129,0.6)] transition-all flex items-center justify-center animate-pulse-glow"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-rose-500 ring-2 ring-[#030712]" />
      </button>
    </div>
  );
}
